// extracted by mini-css-extract-plugin
export var changeIcon = "_6m-4";
export var container = "_6m-0";
export var divider = "_6m-7";
export var externalLinkIcon = "_6m-1";
export var green = "_6m-5";
export var helpCircleIcon = "_6m-3";
export var iconButton = "_6m-2";
export var red = "_6m-6";